var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowC2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#95BF46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3536 18.3536C27.5488 18.1583 27.5488 17.8417 27.3536 17.6464L24.1716 14.4645C23.9763 14.2692 23.6597 14.2692 23.4645 14.4645C23.2692 14.6597 23.2692 14.9763 23.4645 15.1716L26.2929 18L23.4645 20.8284C23.2692 21.0237 23.2692 21.3403 23.4645 21.5355C23.6597 21.7308 23.9763 21.7308 24.1716 21.5355L27.3536 18.3536ZM9 18.5L27 18.5L27 17.5L9 17.5L9 18.5Z",
    fill: "#FEFEFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowC2);
export default __webpack_public_path__ + "static/media/arrow-c2.a3ea33309fe89cef6f26726cd343586f.svg";
export { ForwardRef as ReactComponent };